module.exports = __webpack_public_path__ + "ca1eccfa4c5566fff7564c0aa8ce1f84.jpg";